export enum LoginWithKeycodeFormFieldNames {
  username = "username",
  keycode = "keycode"
}

export type LoginWithKeycodeFormFieldValues = {
  [LoginWithKeycodeFormFieldNames.username]?: string
  [LoginWithKeycodeFormFieldNames.keycode]: string
}